import Vue from 'vue'
export default {
  data () {
    return {
      apiValidationFields: [],
      optionalErrorMessages: [],
      exportFormFlag: false,
      errorMessages: [],
      serviceValidationFields: [],
      serviceValidationError: [],
      validateUpdateErrorMessages: [],
      requiredFieldsError: [],
      pathArray: [],
      updateChanges: [],
      validationFields: ['city', 'cod', 'date', 'email', 'fax', 'npi', 'phone', 'state', 'zip'],
      requiredFields: [null, 'alphanumeric', 'checkbox', 'city', 'cod', 'date', 'email', 'fax', 'npi', 'numeric', 'phone', 'signature', 'state', 'text', 'zip', 'alphanumeric_with_space', 'numeric_with_decimal', 'alpha'],
      requiredGroups: ['multi_select', 'single_select'],
      customFields: ['Patient Home Monitor'],
      logicalGroups: ['npi'],
      resParams: false
    }
  },
  methods: {
    validateForm: async function (formId) {
      return new Promise((resolve, reject) => {
        this.processedDataLoaded = false
        this.resetValidation()
        this.getValidationFields(this.processData)
        if (this.apiValidationFields.length === 0) {
          this.resetTransformersAndShapes('red')
          this.saveData(true)
          this.logFormUpdates(formId)
          this.exportFormFlag = true
          resolve(true)
        }

        if (this.apiValidationFields.length) {
          let apiData = new window.FormData()
          apiData.append('validation_fields', JSON.stringify(this.apiValidationFields))
          apiData.append('service_validation_fields', JSON.stringify(this.serviceValidationFields))
          Vue.axios.post('/forms/validate_form', apiData, { headers: { Authorization: `Bearer ${this.idToken}` }, params: { id: formId } })
            .then(response => {
              if (response.data.message) {
                Vue.toasted.show((response.data.message), { icon: 'chain-broken', type: 'error' })
                this.$router.push('/process/processed')
              } else {
                this.exportFormFlag = true
                const isVaild = response.data.status.valid && response.data.service_validation_response.validated && response.data.required_fields_response.validated
                if (isVaild && response.data.optional_validation.validation_error.length === 0) {
                  this.resetTransformersAndShapes('red')
                } else if (isVaild && response.data.optional_validation.validation_error.length > 0) {
                  this.showAlertMsg(response.data)
                } else {
                  this.exportFormFlag = false
                  this.showAlertMsg(response.data)
                  resolve(false)
                }
                this.resParams = response.data.valid
                this.saveData(response.data.valid)
                if (isVaild) {
                  this.logFormUpdates(formId)
                }
                this.apiValidationFields = []
                this.serviceValidationFields = []
              }
            }, error => {
              this.apiValidationFields = []
              this.serviceValidationFields = []
              this.processedDataLoaded = true
              console.log(error)
            })
        }
      })
    },

    logsUpdateWithSection (pv, pvIndex, eachFormIndex, spareFormData, sectionIndex) {
      if (pv.children) {
        if (pv.data_type === 'multi_select' || pv.data_type === 'single_select') {
          let newData = pv.children.filter(child => child.current_value === 'true').map(ele => ele.key).join(',').trim()
          let oldData = spareFormData[eachFormIndex].children[sectionIndex].children[pvIndex].children.filter(child => child.current_value === 'true').map(ele => ele.key).join(',').trim()
          if (newData !== oldData) {
            this.updateChanges.push({
              key: pv.key,
              data_type: pv.data_type,
              value_before: pv.sensitive_data ? oldData.replace(/./g, '*') : oldData,
              value_after: pv.sensitive_data ? newData.replace(/./g, '*') : newData
            })
          }
        } else if (pv.data_type === 'name') {
          let oldData = spareFormData[eachFormIndex].children[sectionIndex].children[pvIndex]
          pv.children.forEach((pvc, pvcIndex) => {
            if (pvc.current_value !== oldData.children[pvcIndex].current_value) {
              let originalConfidenceScore = parseFloat((oldData.children[pvcIndex].confidence * 100).toFixed(2))
              this.updateChanges.push({
                key: pvc.key,
                data_type: pv.data_type,
                value_before: pvc.sensitive_data ? oldData.children[pvcIndex].current_value.replace(/./g, '*') : oldData.children[pvcIndex].current_value,
                value_after: pvc.sensitive_data ? pvc.current_value.replace(/./g, '*') : pvc.current_value,
                original_confidence_score: originalConfidenceScore,
                modified_confidence_score: 100
              })
            }
          })
        }
      } else if (pv.data_type === 'signature') {
        if (pv.status !== spareFormData[eachFormIndex].children[sectionIndex].children[pvIndex].status) {
          let oldData = spareFormData[eachFormIndex].children[sectionIndex].children[pvIndex]
          this.updateChanges.push({
            key: pv.key,
            data_type: pv.data_type,
            value_before: pv.sensitive_data ? oldData.status.replace(/./g, '*') : oldData.status,
            value_after: pv.sensitive_data ? pv.status.replace(/./g, '*') : pv.status
          })
        }
      } else {
        let oldData = spareFormData[eachFormIndex].children[sectionIndex].children[pvIndex]
        let originalConfidenceScore = parseFloat((oldData.confidence * 100).toFixed(2))
        if (pv.current_value !== oldData.current_value) {
          this.updateChanges.push({
            key: pv.key,
            data_type: pv.data_type,
            value_before: pv.sensitive_data ? oldData.current_value.replace(/./g, '*') : oldData.current_value,
            value_after: pv.sensitive_data ? pv.current_value.replace(/./g, '*') : pv.current_value,
            original_confidence_score: pv.data_type === 'checkbox' ? '' : originalConfidenceScore,
            modified_confidence_score: pv.data_type === 'checkbox' ? '' : 100
          })
        }
      }
    },
    logsUpdateWithoutSection (pv, pvIndex, eachFormIndex, spareFormData) {
      if (pv.children) {
        if (pv.data_type === 'multi_select' || pv.data_type === 'single_select') {
          let newData = pv.children.filter(child => child.current_value === 'true').map(ele => ele.key).join(',').trim()
          let oldData = spareFormData[eachFormIndex].children[pvIndex].children.filter(child => child.current_value === 'true').map(ele => ele.key).join(',').trim()
          if (newData !== oldData) {
            this.updateChanges.push({
              key: pv.key,
              data_type: pv.data_type,
              value_before: pv.sensitive_data ? oldData.replace(/./g, '*') : oldData,
              value_after: pv.sensitive_data ? newData.replace(/./g, '*') : newData
            })
          }
        } else if (pv.data_type === 'name') {
          let oldData = spareFormData[eachFormIndex].children[pvIndex]
          pv.children.forEach((pvc, pvcIndex) => {
            if (pvc.current_value !== oldData.children[pvcIndex].current_value) {
              this.updateChanges.push({
                key: pvc.key,
                data_type: pv.data_type,
                value_before: pvc.sensitive_data ? oldData.children[pvcIndex].current_value.replace(/./g, '*') : oldData.children[pvcIndex].current_value,
                value_after: pvc.sensitive_data ? pvc.current_value.replace(/./g, '*') : pvc.current_value,
                original_confidence_score: oldData.children[pvcIndex].confidence ? oldData.children[pvcIndex].confidence * 100 : '',
                modified_confidence_score: 100
              })
            }
          })
        }
      } else if (pv.data_type === 'signature') {
        let oldData = spareFormData[eachFormIndex].children[pvIndex]
        if (pv.status !== oldData.status) {
          this.updateChanges.push({
            key: pv.key,
            data_type: pv.data_type,
            value_before: pv.sensitive_data ? oldData.status.replace(/./g, '*') : oldData.status,
            value_after: pv.sensitive_data ? pv.status.replace(/./g, '*') : pv.status
          })
        }
      } else {
        let oldData = spareFormData[eachFormIndex].children[pvIndex]
        if (pv.current_value !== oldData.current_value) {
          this.updateChanges.push({
            key: pv.key,
            data_type: pv.data_type,
            value_before: pv.sensitive_data ? oldData.current_value.replace(/./g, '*') : oldData.current_value,
            value_after: pv.sensitive_data ? pv.current_value.replace(/./g, '*') : pv.current_value,
            original_confidence_score: oldData.confidence ? oldData.confidence * 100 : '',
            modified_confidence_score: 100
          })
        }
      }
    },

    getUpdateLogs (formData) {
      this.updateChanges = []
      let spareFormData = this.spareFormData.processed_tree_data
      formData.forEach((eachForm, eachFormIndex) => {
        if (eachForm && eachForm.children) {
          eachForm.children.forEach((sectionData, sectionIndex) => {
            if (sectionData.data_type === 'section') {
              sectionData.children.forEach((pv, pvIndex) => {
                this.logsUpdateWithSection(pv, pvIndex, eachFormIndex, spareFormData, sectionIndex)
              })
            } else {
              this.logsUpdateWithoutSection(sectionData, sectionIndex, eachFormIndex, spareFormData)
            }
          })
        }
      })
      return this.updateChanges
    },

    logFormUpdates (formId) {
      let jsonResult = this.getUpdateLogs(this.formData.processed_tree_data)
      let formDocId = this.formData.form_doc_id
      let params = {
        formId: formId,
        formDocId: formDocId
      }
      if (jsonResult.length) {
        Vue.axios.post('/form_update_logs', {jsonResult}, {headers: { Authorization: `Bearer ${this.idToken}` }, params})
          .then(response => {
            this.spareFormData = JSON.parse(JSON.stringify(this.formData))
          }, error => {
            console.log(error)
            this.spareFormData = JSON.parse(JSON.stringify(this.formData))
          })
      }
    },

    getNonGroupVaidationFields (fieldKey, childData) {
      let vm = this
      if (childData.required) {
        vm.serviceValidationFields.push(childData)
        if (vm.requiredFields.includes(fieldKey)) {
          childData.current_value = childData.current_value.trim()
          vm.apiValidationFields.push(childData)
        }
      } else {
        vm.serviceValidationFields.push(childData)
        if (vm.validationFields.includes(fieldKey)) {
          childData.current_value = childData.current_value.trim()
          vm.apiValidationFields.push(childData)
        }
      }
      if (childData.children && childData.children.length) { vm.getValidationFields(childData.children) }
    },

    getValidationFields (parentData) {
      let vm = this
      parentData.forEach(data => {
        if (data && data.children && Symbol.iterator in Object(data.children)) {
          for (let sectionData of data.children) {
            if (sectionData.data_type === 'section') {
              for (let childData of sectionData.children) {
                let fieldKey = childData.data_type
                if (vm.logicalGroups.includes(fieldKey)) {
                  childData.current_value = childData.current_value.trim()
                  vm.apiValidationFields.push(childData)
                  vm.serviceValidationFields.push(childData)
                } else if (vm.requiredGroups.includes(fieldKey)) {
                  vm.apiValidationFields.push(childData)
                  vm.serviceValidationFields.push(childData)
                } else {
                  vm.getNonGroupVaidationFields(fieldKey, childData)
                }
              }
            } else {
              let fieldKey = sectionData.data_type
              if (vm.logicalGroups.includes(fieldKey)) {
                sectionData.current_value = sectionData.current_value.trim()
                vm.apiValidationFields.push(sectionData)
                vm.serviceValidationFields.push(sectionData)
              } else if (vm.requiredGroups.includes(fieldKey)) {
                vm.apiValidationFields.push(sectionData)
                vm.serviceValidationFields.push(sectionData)
              } else {
                vm.getNonGroupVaidationFields(fieldKey, sectionData)
              }
            }
          }
        }
      })
    },

    showAlertMsg: function (errorMsg) {
      this.validateUpdateErrorMessages = errorMsg.status.errors
      this.serviceValidationError = errorMsg.service_validation_response.validation_error
      this.requiredFieldsError = errorMsg.required_fields_response.validation_error
      this.optionalErrorMessages = errorMsg.optional_validation.validation_error
      this.pathArray = [
        ...this.validateUpdateErrorMessages.flatMap(shape => shape.path),
        ...this.serviceValidationError.flatMap(shape => shape.path),
        ...this.requiredFieldsError.flatMap(shape => shape.path)
      ]
      this.highlightShapeError()
      this.highlightValidationFields(this.processData, false)
      this.$refs.fieldInvalidModal.show()
      this.processedDataLoaded = true
    },
    resetValidation: function () {
      this.apiValidationFields = []
      this.serviceValidationFields = []
      this.errorMessages = []
      this.pathArray = []
      this.highlightValidationFields(this.processData, true)
    },
    highlightShapeError: function () {
      let vm = this
      vm.resetTransformersAndShapes('red')
      for (const path of this.pathArray) {
        let shape = this.baseLayer.find('#' + path)
        shape.setAttrs({
          name: 'selected',
          stroke: 1,
          fill: 'red',
          opacity: 0.2
        })
      }
      vm.baseLayer.draw()
    },
    highlightValidationFields: function (parentData, reset) {
      let vm = this
      for (let childData of parentData) {
        vm.updateValidationState(childData, reset)
        if (childData.children && childData.children.length) { vm.highlightValidationFields(childData.children, reset) }
      }
    },
    updateValidationState: function (childData, reset) {
      if (reset) {
        if (typeof childData === 'object') {
          childData.invalid = null
        }
      } else {
        if (typeof childData === 'object' && this.pathArray.includes(childData.path)) {
          childData.invalid = true
        }
      }
    },
    checkSignatureStatus: function (isSignatureValidated, children) {
      for (let childData of children) {
        if (childData.data_type === 'signature') {
          if (childData.status === 'pending') {
            isSignatureValidated = false
          }
        } else if (childData.map_type === 'group') {
          isSignatureValidated = this.checkSignatureStatus(isSignatureValidated, childData.children)
        }
      }
      return isSignatureValidated
    },
    validateSignature: function () {
      var isSignatureValidated = true
      if (this.formData.template_id !== '-7') {
        isSignatureValidated = this.checkSignatureStatus(isSignatureValidated, this.processData.children)
      }
      return isSignatureValidated
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/mixins/validators.js